<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Countries />
    </div>
</template>

<script>
import currentUserQuery from '@views/Countries/Browse/queryCurrentUser.graphql';

import Countries from '../Countries/Browse.vue';

export default {
  name: 'CountriesContainer',
  components: {
    Countries,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin', 'association'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
